import React from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Field, reduxForm } from 'redux-form'

const ProjectEdit = props => {
  const {
    handleSubmit, submitting, initialValues, onSubmit, uploadImage, goBack, image, imageData,
    searchUser, setUserSelected, collaborator, adminCollaborator, errors,
  } = props
  if (!initialValues) return (<div/>)
  const imageUrl = initialValues && initialValues.imageUrl ? initialValues.imageUrl : 'http://via.placeholder.com/450x253?text=No%20Image'
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">แก้ไขโครงการ</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <form onSubmit={handleSubmit((values) => {
            onSubmit(values, image, collaborator.selected, adminCollaborator.selected)
          })}>
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="form-layout form-layout-5">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <label htmlFor="name" className="col-sm-4 form-control-label">ชื่อโครงการ :</label>
                        <div className="col-sm-8">
                          <Field name="name" component="input" type="text" placeholder="ชื่อโครงการ" className="form-control"
                                 disabled={true}/>
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="description" className="col-sm-4 form-control-label form-label-custom">
                          รายละเอียด :</label>
                        <div className="col-sm-8">
                          <Field name="description" component="textarea" rows="5" placeholder="รายละเอียด"
                                 className="form-control"/>
                          {errors.description ? <span className="text-danger">{errors.description}</span> : undefined}
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="collaborator"
                               className="col-sm-4 form-control-label">ผู้เกี่ยวข้อง :</label>
                        <div className="col-sm-8">
                          <AsyncTypeahead
                            defaultSelected={collaborator.defaultSelected}
                            multiple={true} minLength={1} labelKey="name" placeholder="ค้นหาผู้เกี่ยวข้อง..."
                            isLoading={collaborator.isLoading || false}
                            options={collaborator.list ? collaborator.list.rows : []}
                            onSearch={(query) => searchUser(query, adminCollaborator.selected, 'collaborator')}
                            onChange={(selected) => setUserSelected(selected, 'collaborator')}/>
                          {errors.collaborator ? <span className="text-danger">{errors.collaborator}</span> : undefined}
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="adminCollaborator" className="col-sm-4 form-control-label">
                          ผู้รับผิดชอบหลัก :</label>
                        <div className="col-sm-8">
                          <AsyncTypeahead
                            defaultSelected={adminCollaborator.defaultSelected}
                            multiple={true} minLength={1} labelKey="name" placeholder="ค้นหาผู้รับผิดชอบหลัก..."
                            isLoading={adminCollaborator.isLoading || false}
                            options={adminCollaborator.list ? adminCollaborator.list.rows : []}
                            onSearch={(query) => searchUser(query, collaborator.selected, 'adminCollaborator')}
                            onChange={(selected) => setUserSelected(selected, 'adminCollaborator')}/>
                          {errors.adminCollaborator ?
                            <span className="text-danger">{errors.adminCollaborator}</span> : undefined}
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label className="col-sm-4 form-control-label form-label-custom">รูปภาพโครงการ :</label>
                        <div className="col-sm-8">
                          <div className="card" style={{ maxWidth: '450px' }}>
                            <a href={imageData || imageUrl}>
                              <img src={imageData || imageUrl} alt="" width="100%"/>
                            </a>
                          </div>
                          <br/>
                          <label className="custom-file">
                            <input type="file" className="custom-file-input wd-md-450" accept="image/*" multiple onChange={uploadImage}/>
                            <span className="custom-file-control"></span>
                          </label>
                        </div>
                      </div>
                      <div className="row mg-t-30">
                        <div className="col-sm-8 mg-l-auto">
                          <div className="form-layout-footer">
                            <button type="submit" className="btn btn-teal" disabled={submitting}>แก้ไขโครงการ</button>
                            <span>&nbsp;&nbsp;&nbsp;</span>
                            <button type="button" className="btn btn-secondary" disabled={submitting} onClick={goBack}>กลับ</button>
                          </div>
                        </div>    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>    
    </div>
  )
}

export default reduxForm({
  form: 'project-edit',
  enableReinitialize: true,
})(ProjectEdit)


// WEBPACK FOOTER //
// ./src/components/ProjectEdit.js